import { render, staticRenderFns } from "./TitleH2.vue?vue&type=template&id=1cb53ac4&scoped=true"
import script from "./TitleH2.vue?vue&type=script&lang=ts"
export * from "./TitleH2.vue?vue&type=script&lang=ts"
import style0 from "./TitleH2.vue?vue&type=style&index=0&id=1cb53ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb53ac4",
  null
  
)

export default component.exports